import { gql } from "@apollo/client"
import craftApolloClient from "../api/apollo"

import Head from 'next/head'

import handleContentBlocks from "../../lib/content-blocks"
import handleSeomaticMeta from "../../lib/seomatic"
import { 
    QueryPageHeader,
	QueryText, 
    QueryFlipFlops, 
    QueryFloaters, 
    QueryBillboards, 
    QueryBillboardSliders, 
    QueryImpactFigures, 
    QueryVideos,
    QueryForm,
    QueryProfileCarousel,
    QuerySEO,
	QueryCards,
	QueryOffsetCallout,
	QueryPartners,
	QueryTestimonials,
	QueryCustomSliderVideo,
    QueryCustomQuoteImageGrid
} from "../../graphql/queries"

import { HeaderShim } from "../../fuselage/global/header/header"
import { FooterShim } from "../../fuselage/global/footer/footer"
import { PageHeader } from "../../fuselage/layout/partners/page-header/page-header"
import { LogoTicker , Logo } from "../../fuselage/blocks/logo-ticker/logo-ticker"


function Partners({ seomatic, contentBlocks }) {

	// console.log('seomatic:', seomatic)
	// console.log('contentBlocks:', contentBlocks)

	return (
		<div style={{ width: `100%`, overflow: `hidden` }}>

			<Head>
				{ handleSeomaticMeta( seomatic ) }  
            </Head>

			<HeaderShim />

			<PageHeader />

			<section className="block">
				<div className="container">
					<p className="fs-1 fw-600 c-primary">Benefits of sponsoring FHS Africa include:</p>
				</div>
				<div className="container columns-3 gap-md">
					<div className="formatted">
						<h3>Community Engagement</h3>
						<p>We will create a bespoke community engagement strategy for your company to ensure that you make most of the buzz around our B2B marketing campaign targeting the right industry audiences for you. Our marketing team will create and promote original digital content pieces which will showcase your thought leadership and company to our community through:</p>
						<ul><li><strong>Direct Email</strong> - Reaching over 10,000 industry professionals via email promotion</li><li><strong>Podcasts</strong> - Capturing your unique insights, positioning and value proposition</li><li><strong>Insights</strong> - Short digital or written insights from your company&apos;s thought leader</li><li><strong>Session Marketing</strong> - Highlight your speakers and sessions at FHS Africa</li><li><strong>Advisory Board</strong> - Sharing your insights for the FHS Africa agenda</li></ul>
					</div>
					<div className="formatted">
						<h3>On-Site Engagement</h3>
						<p>Amplifying your presence before, during and after FHS Africa through:</p>
						<ul><li><strong>Social Media</strong> - Twitter, Facebook, Instagram and Linkedin are actively used to promote FHS Africa, its sponsors, speakers and supporters</li><li><strong>Onsite PR</strong> - Working with your PR team and maximising the PR buzz around FHS Africa</li><li><strong>Newsletter</strong> - Featuring your content to our database on hospitality industry professionals</li><li><strong>Daily Wrap Emails</strong> - Mention of your speaker or company&apos;s participation in our daily emails to participants during FHS Africa</li><li><strong>Branding</strong> - Your logo will be positioned on all appropriate promotional pieces related to FHS Africa</li></ul>
					</div>
					<div className="formatted">
						<h3>On-Site Profiling</h3>
						<p>Showcasing your industry presence, thought leadership and products/services to the FHS Africa audience:</p>
						<ul><li><strong>Networking Space In Conference Exhibition</strong> - Showcase your brand/product offering, providing a focal point for attendees to find out more.</li><li><strong>Promotional video</strong> - A visual stimulus that will be played in networking &amp; exhibition areas.</li><li><strong>Speaking position on the programme</strong> - Showcasing your thought leadership</li><li><strong>Access to the attendee list</strong> - Use the list to reach out to attendees and meet them during FHS Africa.</li><li><strong>Opportunity to donate to a local charity</strong> - FHS Africa will organise a charitable activity, in which you can support/participate.</li><li><strong>A private room for meetings and entertainment</strong></li></ul>
					</div>
				</div>
			</section>

			{/* <LogoTicker heading={'FHS Africa 2024 Sponsors & Partners'}>
				{
                    partners &&
                    partners.map( logo => <Logo key={logo.id} logoUrl={logo.logoUrl} />)
                }
			</LogoTicker> */}

			{ handleContentBlocks( contentBlocks, null, null ) }
		
		</div>
	)
}







export async function getStaticProps() {

	const cmsData = await craftApolloClient().query({
        query: gql`
			query Page {
				entry(site: "${process.env.SITE_HANDLE}", id: 15795) {
					title
					... on ${process.env.SITE_HANDLE}Partners_${process.env.SITE_HANDLE}Partners_Entry {
						id
						title
						slug
						${process.env.SITE_HANDLE}ContentBlocks {
							${QueryPageHeader}
							${QueryOffsetCallout}
							${QueryText}
							${QueryFlipFlops}
							${QueryFloaters}
							${QueryBillboards}
							${QueryBillboardSliders}
							${QueryImpactFigures}
							${QueryVideos}
							${QueryCards}
							${QueryProfileCarousel}
							${QueryForm}
							${QueryPartners}
							${QueryTestimonials}
							${QueryCustomSliderVideo}
                            ${QueryCustomQuoteImageGrid}
						}
					}
					${QuerySEO}
				}
			}
        `
    })
	
	return {
		props: { 
			seomatic: cmsData.data.entry.seomatic,
			contentBlocks: cmsData.data.entry.ahifContentBlocks
		}
	}
}

export default Partners


